import { onFID } from 'web-vitals';
import getNodeCSSPath from '../utils/get-node-css-path';

const firstInputDelay = (trackPerformanceMetricEvent) => {
  onFID(({ entries, value }) => {
    const { startTime, target } = entries[entries.length - 1];
    const metadata = {
      css: getNodeCSSPath(target),
      timeStamp: startTime,
    };

    trackPerformanceMetricEvent({
      metric_name: 'first-input-delay',
      metric_type: 'web-vital',
      metric_value: value,
      metric_metadata_type: 'json',
      metric_metadata_value: JSON.stringify(metadata),
    });
  });
};

export default firstInputDelay;
